import React from 'react';
import InvoiceEvaluatorComponent from '../Contents/Operations/PaymentExport/AllExport/InvoiceEvaluatorComponent';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import EvaluatorPaymentStatusEnum from '../Enums/EvaluatorPaymentStatusEnum';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import EvaluatorPaymentTabbed from '../Contents/Operations/PaymentExport/AllExport/EvaluatorPaymentTabbed';

export default class VExportPaymentBaseItem {
  constructor(item) {
    this.initialize(item);
    this.Selected = false;
  }

  async initialize(item) {
    this.ExportPaymentId = item.exportPaymentId;
    this.EvaluatorId = item.evaluatorId;
    this.TpEvaluatorId = item.tpEvaluatorId;
    this.EvaluatorName = item.evaluatorName;
    this.EvCountry = item.evCountry;
    this.EvLastName = item.evLastName;
    this.EvFirstName = item.evFirstName;
    this.EvSassieId = item.evSassieId;
    this.EvSsn = item.evSsn;
    this.EvDdpverify = item.evDdpverify;
    this.EvBankroute = item.evBankroute;
    this.EvBankacct = item.evBankacct;
    this.EvBank = item.evBank;
    this.EvBankAccountHoldersName = item.evBankAccountHoldersName;
    this.EvSwiftcode = item.evSwiftcode;
    this.EvIban = item.evIban;
    this.EvPaypalAddress = item.evPaypalAddress;
    this.EvSortCode = item.evSortCode;
    this.EvBankAddress = item.evBankAddress;
    this.EvBankNum = item.evBankNum;
    this.EvBankZip = item.evBankZip;
    this.EvBankCity = item.evBankCity;
    this.EvBankCountry = item.evBankCountry;
    this.EvEmail = item.evEmail;
    this.EvAccountType = item.evAccountType;
    this.EvId = item.evId;
    this.EvAddress = item.evAddress;
    this.EvAddress2 = item.evAddress2;
    this.EvCity = item.evCity;
    this.EvState = item.evState;
    this.EvZipcode = item.evZipcode;
    this.EvPrefix = item.evPrefix;
    this.EvBankbranch = item.evBankbranch;
    this.EvCpf = item.evCpf;
    this.EvPaypal = item.evPaypal;
    this.EvIfsccode = item.evIfsccode;
    this.EvLngid = item.evLngid;
    this.ExportId = item.exportId;
    this.CurrencyId = item.currencyId;
    this.CurrencyCode = item.currencyCode;
    this.CurrencySymbol = item.currencySymbol;
    this.PaymentMethod = item.paymentMethod;
    this.PaymentMethodName = item.paymentMethodName;
    this.StatusCode = item.statusCode;
    this.StatusCodeName = item.statusCodeName;
    this.PaymentDate = item.paymentDate;
    this.ReconciliationDate = item.reconciliationDate;
    this.TransactionDate = item.transactionDate;
    this.TransactionFee = item.transactionFee;
    this.AdministrativeFee = item.administrativeFee;
    this.TransactionMethod = item.transactionMethod;
    this.TransactionReferenceNumber = item.transactionReferenceNumber;
    this.StatementSentOn = item.statementSentOn;
    this.Notes = item.notes;
    this.VoidReason = item.voidReason;
    this.VoidDate = item.voidDate;
    this.CheckId = item.checkId;
    this.CountryId = item.countryId;
    this.CountryCode = item.countryCode;
    this.CountryName = item.countryName;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedByName = item.modifiedByName;
    this.ModifiedOn = item.modifiedOn;
    this.CreatedBy = item.createdBy;
    this.CreatedByName = item.createdByName;
    this.CreatedOn = item.createdOn;
    this.Yrmo = item.yrmo;
    this.OfficeId = item.officeId;
    this.OfficeName = item.officeName;
    this.ExportDate = item.exportDate;
    this.CheckNumber = item.checkNumber;
    this.Count = item.count;
    this.Fee = item.fee;
    this.FeeOriginal = item.feeOriginal;
    this.FeeBase = item.feeBase;
    this.FeeBaseOriginal = item.feeBaseOriginal;
    this.FeeAdjustment = item.feeAdjustment;
    this.Misc = item.misc;
    this.Travel = item.travel;
    this.Gaming = item.gaming;
    this.Reimbursement = item.reimbursement;
    this.Expense = item.expense;
    this.Total = item.total;
    this.Paid = item.paid;
    this.Due = item.due;
    this.Vat = item.vat;
    this.Expenses = item.misc + item.travel + item.reimbursement + item.gaming;
    this.Fees = item.feeBase + item.feeAdjustment;
    this.EvaluatorContact = item.evaluatorContact;
    this.EvaluatorContactName = item.evaluatorContactName;
    this.EvaluatorContactFirstName = item.evaluatorContactFirstName;
    this.EvaluatorContactLastName = item.evaluatorContactLastName;
    this.EvaluatorContactEmail = item.evaluatorContactEmail;
    this.Surcharge = item.surcharge;
    this.EvClRutNumber = item.evClRutNumber;
    this.EvCnAliPay = item.evCnAliPay;
    this.EvBrBankCode = item.evBrBankCode;
    this.EvBrPis = item.evBrPis;
    this.EvBrCpf = item.evBrCpf;
    this.EvBrAccountType = item.evBrAccountType;
    this.EvBrBrbankBranchNum = item.evBrBrbankBranchNum;
    this.EvBrBrbankAcctNum = item.evBrBrbankAcctNum;
    this.EvWiseEmail = item.evWiseEmail;
    this.WiseTransferCurrency = item.wiseTransferCurrency;
    this.EvSgPayNow = item.evSgPayNow;
    this.EvBrPix = item.evBrPix;
  }

  static NameOfTheIdField() {
    return 'ExportPaymentId';
  }
  static nameOfTheItemDetailList() {
    return 'Export Payments';
  }
  static MoneyFields = [
    'Fee',
    'FeeOriginal',
    'FeeBase',
    'FeeBaseOriginal',
    'FeeAdjustment',
    'Misc',
    'Travel',
    'Gaming',
    'Reimbursement',
    'Expense',
    'Total',
    'Paid',
    'Vat',
    'Expenses',
    'Surcharge',
    'Fees',
    'Due',
    'AdministrativeFee',
    'TransactionFee',
  ];

  static Currency() {
    return 'CurrencyCode';
  }
  static BoolFields = [];

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [
    'ModifiedOn',
    'ExportDate',
    'TransactionDate',
    'StatementSentOn',
    'VoidDate',
    'ReconciliationDate',
    'CreatedOn',
    '',
    '',
  ];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { label: 'Export Payment Id', name: 'ExportPaymentId' },
        { label: 'Export Id', name: 'ExportId' },
        { label: 'Check Number', name: 'CheckNumber' },
        { label: 'Evaluator Name', name: 'EvaluatorName' },
        { label: 'Evaluator Payment Office', name: 'OfficeName' },
        { label: 'Created On', name: (item) => dateTimeHelper.toYYYYsMMsDD(item.CreatedOn) },
        { label: 'Payment Method', name: 'PaymentMethodName' },
        { label: 'Country', name: 'CountryName' },
        { label: 'Modified On', name: (item) => dateTimeHelper.toYYYYsMMsDD(item.ModifiedOn) },
        { label: 'Status', name: 'StatusCodeName' },
        { label: 'Currency', name: 'CurrencyCode' },
        { label: 'Modified By', name: 'ModifiedByName' },

        { label: 'Details', name: '-' },
        { label: 'Fee', name: 'FeeBase' },
        { label: 'Reimbursement', name: 'Reimbursement' },
        { label: 'Gaming', name: 'Gaming' },
        { label: 'Additional Fee', name: 'FeeAdjustment' },
        { label: 'Travel', name: 'Travel' },
        { label: 'Misc', name: 'Misc' },
        { name: '-', label: '' },
        { label: 'Fees', name: 'Fees' },
        { label: 'Expenses', name: 'Expenses' },
        { label: 'Surcharge', name: 'Surcharge' },
        { label: 'VAT', name: 'Vat' },
        { label: 'Due', name: 'Due' },
        { label: 'Paid', name: 'Paid' },

        { label: 'Reconciliation', name: '-' },
        { label: 'Export Date', name: (item) => dateTimeHelper.toYYYYsMMsDD(item.ExportDate) },
        { label: 'Transaction Date', name: (item) => dateTimeHelper.toYYYYsMMsDD(item.TransactionDate) },
        { label: 'Statement Date', name: (item) => dateTimeHelper.toYYYYsMMsDD(item.StatementSentOn) },
        { label: 'Administrative Fee', name: 'AdministrativeFee' },
        { label: 'Transaction Reference #', name: 'TransactionReferenceNumber' },
        { label: 'Void Date', name: (item) => dateTimeHelper.toYYYYsMMsDD(item.VoidDate) },
        { label: 'Transaction Method', name: 'TransactionMethod' },
        { label: 'Transaction Fee', name: 'TransactionFee' },
        { label: 'Reconciliation Date', name: (item) => dateTimeHelper.toYYYYsMMsDD(item.ReconciliationDate) },
        { label: 'Void Reason', name: 'VoidReason', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-', label: '' },
        { label: 'Notes', name: 'Notes', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Payment',
      tabLabel: 'Payment',
      icon: 'fa-solid fa-money-bill-wave',
      data: [
        {
          label: 'Evaluator Invoices',
          name: (item) => <EvaluatorPaymentTabbed exportPaymentId={item.ExportPaymentId} />,
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Export Payment Id',
        orderById: 'ExportPaymentId',
        data: 'ExportPaymentId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      { label: 'Selected', orderById: '', data: VExportPaymentBaseItem.getSelectedCellContent, minWidth: 10 },
      { label: 'Method', orderById: 'PaymentMethodName', data: 'PaymentMethodName', minWidth: 50 },
      { label: 'Status', orderById: 'StatusCodeName', data: 'StatusCodeName', minWidth: 50 },
      { label: 'Total Paid', orderById: 'Total', data: 'Total', minWidth: 50 },
      { label: 'Export Id', orderById: 'ExportId', data: 'ExportId', minWidth: 20 },

      { label: 'Export Office', orderById: 'OfficeName', data: 'OfficeName', minWidth: 50 },
      {
        label: 'Export Date',
        orderById: 'ExportDate',
        data: (item) => dateTimeHelper.toYYYYsMMsDD(item.ExportDate),
        minWidth: 50,
      },
      { label: 'Evaluator', orderById: 'EvaluatorName', data: 'EvaluatorName', minWidth: 200 },
      { label: 'Bravo Evaluator ID', orderById: 'EvaluatorId', data: 'EvaluatorId', minWidth: 20 },
      { label: 'Bravo TP Evaluator ID', orderById: 'TpEvaluatorId', data: 'TpEvaluatorId', minWidth: 20 },
      { label: 'Evaluator Email', orderById: 'EvEmail', data: 'EvEmail', minWidth: 200 },
      {
        label: ' ',
        orderById: '',
        data: VExportPaymentBaseItem.getActionCellContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 50,
      },
    ];
  }

  static getSelectedCellContent(item) {
    return (
      <div className='text-left'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            VExportPaymentBaseItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnSelect(item, selected) {
    //This is a placeholder, don't remove it!
  }

  static getActionCellContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Reconcile',
            onClick: () => VExportPaymentBaseItem.reconcileFunction(item.ExportPaymentId, item),
            iconName: 'fa-solid fa-check',
            disabled: ![EvaluatorPaymentStatusEnum.Pending, EvaluatorPaymentStatusEnum.Paid].includes(item.StatusCode),
            roleKey: 'ExportPayment_ActionButton',
          },
          {
            text: 'Void',
            onClick: () => VExportPaymentBaseItem.voidFunction(item.ExportPaymentId, item),
            iconName: 'fa-solid fa-xmark',
            disabled: ![EvaluatorPaymentStatusEnum.DeferredOrErrorAtTipalti].includes(item.StatusCode),
            roleKey: 'ExportPayment_ActionButton',
          },
          {
            text: 'Void & Reissue',
            onClick: () => VExportPaymentBaseItem.voidAndReissueFunction(item.ExportPaymentId, item),
            iconName: 'fa-solid fa-rotate-right',
            disabled: ![EvaluatorPaymentStatusEnum.DeferredOrErrorAtTipalti].includes(item.StatusCode),
            roleKey: 'ExportPayment_ActionButton',
          },
          {
            text: 'Void & Suppress',
            onClick: () => VExportPaymentBaseItem.voidAndSuppressFunction(item.ExportPaymentId, item),
            iconName: 'fa-solid fa-trash',
            disabled: ![EvaluatorPaymentStatusEnum.DeferredOrErrorAtTipalti].includes(item.StatusCode),
            roleKey: 'ExportPayment_ActionButton',
          },
          {
            text: 'Resend Statement',
            onClick: () => VExportPaymentBaseItem.resendEvaluatorStatementFunction(item.ExportPaymentId, item),
            iconName: 'fa-solid fa-envelope',
            disabled: ![EvaluatorPaymentStatusEnum.Paid, EvaluatorPaymentStatusEnum.Reconciled].includes(
              item.StatusCode
            ),
            roleKey: 'EvaluatorPayment_ResendStatement_ActionButton',
          },
        ]}
      />
    );
  }

  static reconcileFunction(exportPaymentId, item) {
    //This is a placeholder, don't remove it!
  }

  static voidFunction(exportPaymentId, item) {
    //This is a placeholder, don't remove it!
  }

  static voidAndReissueFunction(exportPaymentId, item) {
    //This is a placeholder, don't remove it!
  }

  static voidAndSuppressFunction(exportPaymentId, item) {
    //This is a placeholder, don't remove it!
  }
}
